import { Directive, ElementRef, EventEmitter, inject, Input, OnDestroy, OnInit, Output } from '@angular/core';


@Directive({
  selector: '[muiEnter]',
  standalone: true
})
export class MuiPresenceDirective<T = unknown> implements OnInit, OnDestroy {
  @Input()
  muiEnter?: T;

  @Output()
  enter = new EventEmitter<T | ElementRef>();

  @Output()
  exit = new EventEmitter<T | ElementRef>();

  private _elementRef = inject(ElementRef);

  ngOnInit(): void {
    this.enter.emit(this.muiEnter ?? this._elementRef);
    this.enter.complete();
  }

  ngOnDestroy(): void {
    this.exit.emit(this.muiEnter ?? this._elementRef);
    this.exit.complete();
  }
}
